<template lang="pug">
  .site-firmwares-view
    el-breadcrumb.mt-3.last-breadcrumb-bold(style="font-size: 22px;" separator="/")
      el-breadcrumb-item {{ 'Management' }}
      el-breadcrumb-item(:to="{ name: 'sites' }") {{ 'Sites' }}
      el-breadcrumb-item {{ 'Firmwares' }}
    .site-firmwares-wrapper
      .actions
        el-button.dark-green-btn(
          @click="handleOpenAddFirmwareDialog"
        )
          h4 {{ $t('firmwares.actions.add') }}
      el-row
        el-col(:span='24')
          SiteFirmwaresViewTable(
            v-loading="loading"
            :firmwares="firmwares"
            :siteId="siteId"
          )
    Pagination(
      :view="'site_firmwares'"
      :siteId="siteId"
      @viewData="handleGetFirmwares"
      @handleTableLoading="handleLoading"
    )
    AddFirmware(
      v-if="isAddFirmwareDialogVisible"
      :siteId="siteId"
    )
</template>

<script>
import Pagination from "@components/_shared/Pagination";
import SiteFirmwaresViewTable from "@components/firmwares/SiteFirmwaresViewTable";
import AddFirmware from "@components/dialogs/templates/AddFirmware";
import { mapMutations, mapState } from "vuex";

export default {
  name: 'SiteFirmwaresView',
  components: { Pagination, SiteFirmwaresViewTable, AddFirmware },

  data() {
    return {
      firmwares: [],
      loading: false,
    };
  },

  computed: {
    siteId() {
      return this.$route.params.id;
    },

    ...mapState("dialog", ["isAddFirmwareDialogVisible"]),
  },

  methods: {
    ...mapMutations("dialog", ["showAddFirmwareDialog"]),

    handleGetFirmwares(data) {
      this.firmwares = data;
    },

    handleLoading(loading) {
      this.loading = loading;
    },

    handleOpenAddFirmwareDialog() {
      this.showAddFirmwareDialog();
    },
  },
};
</script>
